

"use client";
import AIToolkit from "@/components/AIToolkit";
import ComparisonChart from "@/components/ComparisonChart";
import EvaluateTalent from "@/components/EvaluateTalent";
import FeatureComparison from "@/components/FeatureComparison";
import FeaturesGrid from "@/components/FeaturesGrid";
import Footer from "@/components/Footer";
import FrequentlyAskedQuestion from "@/components/FrequentlyAskedQuestion";
import GetgeekBeforeAfter from "@/components/GetgeekBeforeAfter";
import GetgeekHiring from "@/components/GetgeekHiringCircular";
import GuaranteeComponent from "@/components/GuaranteeComponent";
import HeroSection from "@/components/HeroSection";
import LogoCarousel from "@/components/LogoCarousel";
import Main from "@/components/Main";
import Navbar from "@/components/Navbar";
import QualifiedCandidates from "@/components/QualifiedCandidates";
import SocialProof from "@/components/SocialProof";
import TestimonialsComponent from "@/components/TestimonialsComponent";
import ThreeEasySteps from "@/components/ThreeEasySteps";
import VideoUIComponent from "@/components/VideoUIComponent";
import ScrollReveal from "@/components/ScrollReveal";
import IntroAnimation from "@/components/IntroAnimation";
import React, { useEffect, useState } from "react";
import "../app/globals.css";
import getUserRegion from "@/utils/getUserRegion";
import Banner from "@/components/Banner";
import PricingTable from "@/components/PricingTable";
import CTASection from "@/components/CTASection";
import WhatGetgeekDoes from "@/components/WhatGetgeekDoes";
import LandingPageYellowCTA from "@/components/LandingPageYellowCTA";
import HiringProcess from "@/components/HiringProcess";

const LandingPage = () => {
  const [showIntro, setShowIntro] = useState(true);
  const [offersData, setOffersData] = useState(null);

  useEffect(() => {
    console.log("Landing page loaded, getting user region...");
    getUserRegion();

    // Check if offers data exists in localStorage
    const savedOffers = localStorage.getItem("activeOffers");
    if (savedOffers) {
      try {
        const parsedOffers = JSON.parse(savedOffers);
        setOffersData(parsedOffers);
        console.log("Loaded offers from localStorage:", parsedOffers);
      } catch (error) {
        console.error("Error parsing saved offers:", error);
      }
    }

    // Fetch active offers from API
    const fetchOffers = async () => {
      try {
        const response = await fetch(
          "https://www.super-admin.getgeek.ai/nest_backend/offers/active",
        );
        if (response.ok) {
          const data = await response.json();
          setOffersData(data);
          // Save to localStorage
          localStorage.setItem("activeOffers", JSON.stringify(data));
          console.log("Active offers fetched and saved:", data);
        } else {
          console.error("Failed to fetch offers:", response.status);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };

    fetchOffers();
  }, []);

  const handleAnimationComplete = () => {
    console.log("Intro animation completed");
    setShowIntro(false);
  };

  return (
    <IntroAnimation
      showIntro={showIntro}
      onAnimationComplete={handleAnimationComplete}
    >
      <div>
        <Navbar />
        <Main />
        {/* Logo carousel with subtle animation */}
        <ScrollReveal delay={0.1} duration={1.0}>
          <LogoCarousel />
        </ScrollReveal>
        <ScrollReveal delay={0.1} duration={1.0}>
          <WhatGetgeekDoes />
        </ScrollReveal>
        {/* Testimonials with staggered animation */}
        <ScrollReveal delay={0.2} duration={1.2}>
          <TestimonialsComponent />

        </ScrollReveal>
        {/* Video section with smooth reveal */}
        <ScrollReveal delay={0.1} duration={1.0}>
          <VideoUIComponent />
        </ScrollReveal>
        {/* Hiring circular with animation */}
        <ScrollReveal delay={0.3} duration={1.1}>
          <GetgeekHiring />
        </ScrollReveal>
        {/* Before/After comparison with reveal */}
        {/* <ScrollReveal delay={0.2} duration={1.0}>
          <GetgeekBeforeAfter />
        </ScrollReveal> */}
        {/* Hero section with animation */}
        <ScrollReveal delay={0.1} duration={1.2}>
          <HeroSection />
        </ScrollReveal>
        {/* Social proof with smooth animation */}
        <ScrollReveal delay={0.2} duration={1.0}>
          <SocialProof />
        </ScrollReveal>
        <ScrollReveal delay={0.2} duration={1.0}>
          <LandingPageYellowCTA />
        </ScrollReveal>
        {/* AI Toolkit with reveal animation */}
        <ScrollReveal delay={0.3} duration={1.1}>
          <AIToolkit />
        </ScrollReveal>
        {/* Features grid with staggered animation */}
        <ScrollReveal delay={0.1} duration={1.0}>
          <FeaturesGrid />
        </ScrollReveal>
        {/* <HiringProcess/> */}
        {/* Talent evaluation with smooth reveal */}
        <ScrollReveal delay={0.2} duration={1.2}>
          <EvaluateTalent />
        </ScrollReveal>
        {/* Comparison chart with animation */}
        {/* <ScrollReveal delay={0.1} duration={1.0}>
          <ComparisonChart />
        </ScrollReveal> */}
        {/* Feature comparison with reveal */}
        <ScrollReveal delay={0.3} duration={1.1}>
          <FeatureComparison />
        </ScrollReveal>
        <ScrollReveal delay={0.3} duration={1.1}>
          <ThreeEasySteps />
        </ScrollReveal>
        <ScrollReveal delay={0.3} duration={1.1}>
          <PricingTable />
        </ScrollReveal>
        {/* Guarantee component with smooth animation */}
        <ScrollReveal delay={0.2} duration={1.0}>
          <GuaranteeComponent />
        </ScrollReveal>
        {/* Qualified candidates with reveal */}
        <ScrollReveal delay={0.1} duration={1.2}>
          <QualifiedCandidates />
        </ScrollReveal>
        {/* FAQ section with smooth animation */}
        <ScrollReveal delay={0.2} duration={1.0}>
          <FrequentlyAskedQuestion />
        </ScrollReveal>
        {/* Footer - no animation needed */}
        <Footer />
      </div>
    </IntroAnimation>
  );
};

export default LandingPage;